<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-sheet class="mt-3 ml-3">
          <v-row>
            <v-col cols="4">
              <CommonFieldString
                  v-model="currentItem.name"
                  label="Name"
                  class="mt-1"
              ></CommonFieldString>
              <CommonFieldText
                  v-model="currentItem.description"
                  label="Description"
                  class="mt-3"
              ></CommonFieldText>
              <CommonPartialSelectFromTable
                  v-model="currentItem.parent_uid"
                  dto-list-query="MaterialLocationListQueryDTO"
                  store-name="SelectMaterialLocation"
                  :sort-by="['parent__name', 'name']"
                  item-text="fullname"
                  label="Parent"
                  class="mt-3"
              >
              </CommonPartialSelectFromTable>
              <TemperatureSelect v-model="currentItem.temperature"></TemperatureSelect>
            </v-col>
            <v-col cols="8">
              <MaterialTable
                  :title="$t('material')"
                  :top-height="storeDetail.modalDialog === false ? 80 : 170"
                  dtoListQuery="MaterialListQueryDTO"
                  :store-name="storeMaterialTableName"
              >
                <template v-slot:footer.prepend>{{''}}</template>
              </MaterialTable>
            </v-col>
          </v-row>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonFieldText from "@/components/Common/CommonFieldText";
import {useTableStore} from "@/components/Common/CommonTable";
import TemperatureSelect from "@/components/CoreMaterial/MaterialLocation/TemperatureSelect.vue";

export default {
  name: "MaterialLocationDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'MaterialLocationDetail'},
    dtoDetailQuery: {default: 'MaterialLocationDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialLocationActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'MaterialLocationSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'MaterialLocationValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'MaterialLocationBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'MaterialLocationTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    TemperatureSelect,
    CommonFieldString,
    CommonFieldText,
    CommonDetail,
    CommonPartialSelectFromTable,
    'MaterialTable': () => import("@/components/CoreMaterial/Material/MaterialTable"),
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.storeMaterialTable.filters = this.storeMaterialTable.filters.filter(x => x.param_compare !== 'location__uid')
        this.storeMaterialTable.filters.push({param_compare: 'location__uid', value: this.storeDetail.uidItem})
      }
    },
  },

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    this.storeMaterialTable = useTableStore(this.storeMaterialTableName)()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeMaterialTable: null,
      storeMaterialTableName: uuidv4(),
    }
  }
  ,
}
</script>

<style scoped>

</style>